import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser,CreateUserObject } from '../api';
import './LoginForm.css';
import { ContextEngine } from "../TractumUI/engine/ContextEngine";

export default function LoginForm({ onLogin }) {
  const { updateContext } = useContext(ContextEngine);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false); // toggle state

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const data = await loginUser(username, password);
      // 2. Format it into your "User Class" structure
      const formattedUser = CreateUserObject(data);
      // 3. Inject it into your Engine's state
      updateContext("user", formattedUser);
      localStorage.setItem("user_session", JSON.stringify(formattedUser));
      onLogin();
      navigate('/tracta');
    } catch (err) {
      const detail = err?.detail;
      console.error("DEBUG - Full Error Object:", err); // 🚀 ADD THIS LINE
      
      // Check if detail is object with message
      if (detail && detail.message) {
        setError(detail.message);
      } else if (typeof detail === "string") {
        setError(detail);
      } else {
        setError("Login failed");
      }
    }
  };

  return (
    <div className="login-container light-theme-only">
      <div className="login-box">
      <img 
        src={process.env.PUBLIC_URL + '/elephant_64.png'}
        alt="Logo"
        className="login-logo"
      />
        <h1>Tractum Admin</h1>
        <form onSubmit={handleSubmit} className="login-form">

          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
              <span 
                className="toggle-password" 
                onClick={() => setShowPassword(prev => !prev)}
              >
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>
          </div>

          <button type="submit" className="login-btn">Log in</button>
          {error && <p className="error-text">{error}</p>}
        </form>
      </div>
    </div>
  );
}
